<template>
    <div id="gjsWrapper" style="display: none">
        <div class="panel__top border rounded" style="background-color: #fff">
            <div class="panel__switcher"></div>
<!--            <div class="panel__custom">-->
<!--&lt;!&ndash;                <b-field>&ndash;&gt;-->
<!--&lt;!&ndash;                    <b-slider v-model="value"></b-slider>&ndash;&gt;-->
<!--&lt;!&ndash;                </b-field>&ndash;&gt;-->
<!--            </div>-->
            <div class="panel__devices">
            </div>
            <div class="panel__basic-actions"></div>
        </div>
        <div class="editor-row">
            <div class="panel__left">
                <div class="blocks-container">
                    <div class="panel-headline">
                        Elemente
                    </div>
                </div>
                <div class="layers-container" style="display: none">
                    <div class="panel-headline">
                        Aufbau
                    </div>
                </div>
                <div class="styles-container"></div>
                <div class="traits-container" style="display: none">
                    <div class="panel-headline">
                        Einstellungen
                    </div>
                </div>
            </div>
            <div class="editor-canvas">
                <div id="gjs">
                </div>
            </div>
        </div>
    </div>
    <div class="rendered" v-html="html">

    </div>
</template>

<script>
    import grapesjs from 'grapesjs';
    import de from 'grapesjs/src/i18n/locale/de'

    import components from "./components";
    import blocks from "./blocks";
    import { renderSessions } from "../../common/lp-render";
    localStorage.removeItem('gjs-assets')
    export default {
        name: "GrapesJSRender",
        props: {
          components: Array
        },
        data() {
            return {
                editor: null,
                value: 0,
              html: ''
            }
        },
        mounted() {
            this.editor = grapesjs.init({
                i18n: {
                    locale: 'de',
                    localeFallback: 'de',
                    // detectLocale: 1,
                    // debug: 0,
                    messages: {
                        de
                    }
                },
                blockManager: {
                    appendTo: '.blocks-container',
                    blocks
                },
                layerManager: {
                    appendTo: '.layers-container'
                },
                // selectorManager: {
                //     appendTo: '.styles-container'
                // },
                // storageManager: {type: null},
                cssIcons: null,
                container: '#gjs',
                fromElement: true,
                // styleManager,
                plugins: [
                    components
                ]
            });

            // domComponents(this.editor)
            this.html = this.editor.getHtml()
          //this.editor.destroy()
          const element = document.getElementById("gjsWrapper");
          element.parentNode.removeChild(element);
        },
        computed: {
          assets() {
            let r = [
              'https://api.events.webapps.sendnode.com/assets/uploads/event_14/3UIWS_2M62X_Logo_weiße_Bildmarke_zweizeilig-01-01.png'
            ]
            //if(Array.isArray(this.$root.env.account.media)) this.$root.env.account.media.forEach(m => r.push(m.url))
            return r
          }
        },
      watch: {
          html: function() {
            this.$nextTick(() => {
              const sessionsRoot = document.querySelector('.et-sessions');
              renderSessions(sessionsRoot, this.$store);
            })
          }
      }
    }
</script>

<style lang="css">
    @import '../../../node_modules/grapesjs/dist/css/grapes.min.css';
    /*@import "grapesjs/src/styles/scss/main.scss";*/

    #gjsWrapper{
        height: 100%;
    }

    /* Let's highlight canvas boundaries */
    #gjs {
        border: none;
    }

    /* Reset some default styling */
    .gjs-cv-canvas {
        top: 0;
        width: 100%;
        height: 100%;
    }

    .gjs-block {
        width: 100%;
        height: auto;
        min-height: auto;
    }

    .panel__top {
        padding: 0;
        width: 100%;
        display: flex;
        position: initial;
        justify-content: center;
        justify-content: space-between;
        @apply mb-2
    }

    .panel__top.gjs-hidden{
        display: none;
    }

    .gjs-off-prv{
        float: right;
    }

    .panel__basic-actions {
        position: initial;
        display: flex;
    }
    .panel__basic-actions.gjs-hidden {
        display: none;
    }

    .editor-row {
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        flex-wrap: nowrap;
      height: calc(100% - 50px)
    }

    .editor-canvas {
        flex-grow: 1;
    }

    .panel__left {
        flex-basis: 230px;
        position: relative;
        overflow-y: auto;
      @apply  border rounded bg-white mr-2 !important
    }

    .panel__switcher {
        position: initial;
        border-radius: inherit;
    }

    .panel__devices {
        position: initial;
    }

    /* Theming */

    /* Primary color for the background */
    .gjs-one-bg {
        background-color: #ffffff00;
    }

    /* Secondary color for the text color */
    .gjs-two-color {
        color: #001930;
    }

    /* Tertiary color for the background */
    .gjs-three-bg {
        background-color: #587dec;
        color: white;
    }

    /* Quaternary color for the text color */
    .gjs-four-color,
    .gjs-four-color-h:hover {
        color: #001930;
    }

    .gjs-field-checkbox input:checked+.gjs-chk-icon{
        border-color: #001930;
    }

    /*     Custom     */
    .panel-headline{
        font-weight: bold;
    }

    .gjs-am-file-uploader{
        display: none;
    }

    .gjs-am-assets-cont{
        width: 100%;
        float: none;
    }


    .fa-trash-o:before {
      content: '\f1f8';
    }

    .gjs-title{
      @apply bg-gray-200 border-gray-400 rounded border !important
    }

    .gjs-block-category{
      @apply mb-2 border-0 !important
    }
</style>

